import React from 'react';
import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px 36px;
  border-radius: ${({ theme }) => theme.radii.md};
  font-weight: 700;
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.default};
  font-size: 16px;
  cursor: pointer;
  border: none;

  ${({ variant, theme }) => {
    switch (variant) {
      case 'secondary':
        return css`
          background: ${theme.colors.lighter};
          color: ${theme.colors.primary};
          box-shadow: ${theme.shadows.sm};
          border: 1px solid ${theme.colors.lightGray};
          &:hover {
            transform: translateY(-3px);
            box-shadow: ${theme.shadows.md};
            border-color: ${theme.colors.primaryLight};
          }
        `;
      default: 
        return css`
          background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.accent} 100%);
          color: ${theme.colors.lighter};
          box-shadow: 0 6px 20px rgba(108, 92, 231, 0.4);
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 30px rgba(108, 92, 231, 0.5);
          }
        `;
    }
  }}
`;

const Button = ({ children, variant = 'primary', ...props }) => {
  return (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;